import { render, staticRenderFns } from "./word.vue?vue&type=template&id=12e4b53a&scoped=true"
import script from "./word.vue?vue&type=script&lang=js"
export * from "./word.vue?vue&type=script&lang=js"
import style0 from "./word.vue?vue&type=style&index=0&id=12e4b53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4b53a",
  null
  
)

export default component.exports